import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import {
  IDENTIFICATIONCODETYPES_RESOURCE,
  IDENTIFICATIONCODETYPE_RESOURCE,
  UPDATE_IDENTIFICATIONCODETYPE_RESOURCE,
} from '../constants';
import { createErrorMessage } from '../../app/helpers/createErrorMessage';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_IDENTIFICATIONCODETYPE_RESOURCE,
      method: 'put',
      request: (id, body, callback, t) => ({
        url: apiRoutes.identificationCodeTypes(id),
        body,
        meta: {
          callback,
          updateOtherList: {
            resource: IDENTIFICATIONCODETYPES_RESOURCE,
            id,
            idProp: 'id',
          },
          setOther: {
            resource: IDENTIFICATIONCODETYPE_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updateIdentificationCodeTypeFailed'),
            onSuccessMessage: t('updateIdentificationCodeTypeSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);
